import {
    IListarClientesParcelasAtraso,
    IListarParcelasAtrasoPorCliente,
    ILstParcelasAtrasoPorClienteBody,
    INegativarParcelasClientes,
} from "../../../../Interfaces/Cobranca/Serasa/Negativar";
import Axios from "../../../Config/API";
import Service from "../../../Service";

export function ListarClientesParcelasAtrasoSerasaService(
    PAGINA: number,
    requestBody: {
        DS_CLIENTE: string;
        ID_EMPREENDIMENTO: string | number[];
        NR_CPF_CNPJ: string;
        DS_TIPO_CLIENTE: string;
        DS_STATUS_PARCELA: string;
        NR_VENDA: string;
        QUANTIDADE: number;
        PAGINA: number;
    }
) {
    return Service(
        Axios.post<IListarClientesParcelasAtraso>(
            `/serasa/negativacaoserasa/listarclientesparcelasatraso?PAGINA=${PAGINA}`,
            requestBody
        )
    );
}

export function ListarClientesParcelasAtrasoSerasaExportarExcelService(
    PAGINA: number,
    requestBody: {
        DS_CLIENTE: string;
    },
    flExcel?: boolean
) {
    return Service(
        Axios.post<Blob>(
            `/serasa/negativacaoserasa/listarclientesparcelasatraso?PAGINA=${PAGINA}&flExcel=${flExcel}`,
            requestBody,
            { responseType: "blob" }
        )
    );
}

export function ListarParcelasAtrasoPorClienteSerasaService(
    PAGINA: number,
    QUANTIDADE: number,
    requestBody: {
        DS_NOME: string;
        ID_CHAVE_ERP: string;
        DS_STATUS: string;
        DS_TIPO_CLIENTE?: boolean;
    }
) {
    return Service(
        Axios.post<IListarParcelasAtrasoPorCliente>(
            `/serasa/negativacaoserasa/listarparcelasatrasoporcliente?PAGINA=${PAGINA}&QUANTIDADE=${QUANTIDADE}`,
            requestBody
        )
    );
}

export function ListarParcelasAtrasoPorClienteSerasaExportarExcelService(
    PAGINA: number,
    QUANTIDADE: number,
    requestBody: ILstParcelasAtrasoPorClienteBody,
    flExcel?: boolean
) {
    return Service(
        Axios.post<Blob>(
            `/serasa/negativacaoserasa/listarparcelasatrasoporcliente?PAGINA=${PAGINA}&QUANTIDADE=${QUANTIDADE}&flExcel=${flExcel}`,
            requestBody,
            { responseType: "blob" }
        )
    );
}

export function ExecutarNegativacaoClienteSerasaService(
    requestBody: Array<INegativarParcelasClientes>
) {
    return Service(
        Axios.post(
            `/serasa/negativacaoserasa/executarnegativacaocliente`,
            requestBody
        )
    );
}
